import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import PersonnelForm from "../../components/Personnel/PersonnelForm";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";

const BuildingEdit = ({classes, personnel,professions,assignedUsers}) => {

    let action = personnel.id ? 'edit' : 'add';


    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('personnel.' + action)}
            />
            <Card>
                <CardContent>
                    <PersonnelForm
                        values={{...personnel,professions:professions,assigned_users:assignedUsers} || {}}
                    />
                </CardContent>
            </Card>
        </Layout>
    )
};

export default BuildingEdit;
